import React, { Component } from 'react'
import { Spinner } from 'react-bootstrap';

export default class HotSpotLoadingPage extends Component {

    render() {
        const constStyle = {
            width: '100%',
            height: '100%',
            margin: 'auto',
            textAlign: 'center',
            background: '#fff',
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }

        return (
            <section style={{...constStyle}}>
                <Spinner animation="grow" variant="warning"/>
            </section>
        )
    }
}
